var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpField = require('./ReUpField.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpText = require('./ReUpText');
var PlatformConstants = require('./constants/PlatformConstants');
var AnalyticsManager = require('./AnalyticsManager');
var Icon = require('./wrappers/ReUpIcon');
var Keyboard = require('./wrappers/Keyboard-wrapper');

var MK = require('./wrappers/react-native-material-kit-wrapper');

var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKIconToggle
} = MK;

const FBSDK = require('./wrappers/react-native-fbsdk-wrapper');
const {
  LoginManager,
  AccessToken,
} = FBSDK;

var FeedCard = require('./feedCard.js');

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  StyleSheet,
  Platform,
} = ReactNative;

var Login = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout
    }
  },

  componentDidMount : function()
  {
    var thisThing = this;
    setTimeout(function()
    {
      if( typeof thisThing._ref_loginCard !== 'undefined' && thisThing._ref_loginCard != null ) thisThing._ref_loginCard.focus();
    }, 400)
  },

  didUpdate(data)
  {

  },

  loginPressed : function(username, password)
  {
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var thisThing = this;
    var loggingIn = this.props.appManager.getLocalizationManager().localizedStringForKey("LOGIN_HUD");
    appActions.setSpinnerShown(true, loggingIn);
    Keyboard.dismiss();
    NetworkManager.login(appManager, username.trim(), password, function(data)
    {
      AnalyticsManager.logLoginEvent(appManager, 'regular', true);
      data[ModelConstants.Password] = password;
      appManager.setCurrentUser(data, function()
      {
        appActions.setSpinnerShown(false);
        if( data[ModelConstants.DirtyPassword] == 1 )
        {
          thisThing.showChangePass();
        }
        else
        {
          appActions.requestPop(true);
        }
      })
    }, function(data)
    {
      AnalyticsManager.logLoginEvent(appManager, 'regular', false);
      appActions.setSpinnerShown(false);
      if( data.code == -23 ) // not verified
      {
        appActions.showLocalizedAlert("UNVERIFIED_FAIL_ALERT_TITLE", "UNVERIFIED_FAIL_ALERT_BODY", ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [appActions.hideAlert, function()
        {
          appActions.setSpinnerShown(true, "");
          NetworkManager.resendVerifyEmail(appManager, username, function()
          {
            appActions.showLocalizedAlert("EMAIL_PASS_SUCCESS_ALERT_TITLE", "CREATEUSER_SUCCESS_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert)
            appActions.setSpinnerShown(false);
          }, function()
          {
            appActions.showLocalizedAlert("CREATEUSER_EMAIL_INVALID_FAIL_ALERT_TITLE", "CREATEUSER_EMAIL_INVALID_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert)
            appActions.setSpinnerShown(false);
          }, function()
          {
            appActions.showNetworkErrorAlert(appActions.hideAlert, function(){});
            appActions.setSpinnerShown(false);
          })
        }], appActions.hideAlert)
      }
      else
      {
        appActions.showLocalizedAlert("LOGIN_FAIL_ALERT_TITLE", "LOGIN_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert)
      }

    }, function(data)
    {
      AnalyticsManager.logLoginEvent(appManager, 'regular', false);
      appActions.setSpinnerShown(false);
      appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert)
    })
  },

  loginFacebookPressed : function()
  {
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var thisThing = this;
    appActions.setSpinnerShown(true);
    LoginManager.logInWithReadPermissions(['email','public_profile']).then(
    function(result)
    {
      if (result.isCancelled)
      {
        console.log("Facebook cancelled");
        appActions.setSpinnerShown(false);
      }
      else
      {
        AccessToken.getCurrentAccessToken().then(
        (data) =>
        {
          var password = data.accessToken.toString();
          NetworkManager.createUserFacebook( appManager, password, "", true, (email)=>
          {
            NetworkManager.login(appManager, email, password, (data)=>
            {
              data[ModelConstants.Password] = password;
              appManager.setCurrentUser(data, function()
              {
                appActions.setSpinnerShown(false);
                appActions.requestPop(true);
              })
            }, ()=>
            {
              appActions.setSpinnerShown(false);
              appActions.showLocalizedAlert("LOGIN_FAIL_ALERT_TITLE", "LOGIN_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert)
            }, ()=>
            {
              appActions.setSpinnerShown(false);
              appActions.showLocalizedAlert("LOGIN_FAIL_ALERT_TITLE", "LOGIN_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert)
            })
          }, ()=>
          {
            appActions.setSpinnerShown(false);
            appActions.showLocalizedAlert("LOGIN_FAIL_ALERT_TITLE", "LOGIN_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert)
          })
        })
      }
    },
    function(error)
    {
      appActions.setSpinnerShown(false);
      appActions.showLocalizedAlert("LOGIN_FAIL_ALERT_TITLE", "LOGIN_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert)
      console.log('Login fail with error: ' + error);
    });
  },

  _showPassword : false,
  _currentPassword : "",
  _newPassword : "",
  _currentPasswordError: false,
  _newPasswordError: false,
  showChangePass : function()
  {
    var thisThing = this;
    var appManager = thisThing.props.appManager;
    var appActions = thisThing.props.appActions;
    var locManager = thisThing.props.appManager.getLocalizationManager();
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var generalColor = 'white';//appManager.getColorForKey("GeneralColor");
    var generalTitleColor = 'black';//appManager.getColorForKey("GeneralTitleColor");
    var bannerColor = 'black';//appManager.getColorForKey("FeedCardBannerColor");

    var locMan = appManager.getLocalizationManager();
    var changePasswordButton = locMan.localizedStringForKey("CHANGE_PASSWORD_BUTTON");
    var newPassDescription = locMan.localizedStringForKey("SET_NEW_PASSWORD_STATEMENT");
    var newPassPlaceholder = locMan.localizedStringForKey("NEW_PASSWORD_PLACEHOLDER");
    var currPass = appManager.currentUser()[ModelConstants.Password];

    var customAlert =
      <ScrollView bounces={true} style={{margin:0,padding:2,marginLeft:10,marginRight:10}}
        keyboardShouldPersistTaps={true}
        keyboardDismissMode={"interactive"}>
        <View style={{flexDirection:'column'}}>
          <ReUpText appManager={appManager} isTitle={true} style={{marginTop:10, textAlign:'center'}}>
            {"Change Password"}
          </ReUpText>
          <ReUpText appManager={appManager} style={{marginTop:10, textAlign:'center'}}>
            {newPassDescription}
          </ReUpText>
          <View style={{flexDirection:'row'}}>
            <ReUpField
              onChangeText={(text) => {this._newPassword = text}}
              key="password"
              ref={(a) => { thisThing._passwordField = a }}
              tintColor={bannerColor}
              highlightColor={bannerColor}
              textInputStyle={{color: generalTitleColor, fontFamily:'Arial'}}
              appManager={appManager}
              placeholder={newPassPlaceholder}
              secureTextEntry={!this._showPassword}
              style={[{flex:1, alignSelf:'center', height:50}]}/>

            <MKIconToggle
              style={{marginTop:22, height:30, width:30, position:'absolute', right:0, backgroundColor:'transparent'}}
              checked={this._showPassword}
              onCheckedChange=
              {
                (info) => {
                  thisThing._passwordField.onBlur();
                  thisThing._showPassword = info.checked;
                  thisThing.showChangePass();
                }
              }
              >
              <Icon pointerEvents="none" state_checked={true} style={[styles.creditCardEditButtonIcon]} name={"eye"} size={14} color={generalTitleColor} />
              <Icon pointerEvents="none" state_checked={false} style={[styles.creditCardEditButtonIcon]} name={"eye-slash"} size={14} color={generalTitleColor} />
            </MKIconToggle>

          </View>
          <ReUpButton onPress={() =>
            {
              if( appManager.isValidPassword(thisThing._newPassword) )
              {
                thisThing.changePassword(thisThing._newPassword);
              }
              else
              {
                appActions.showLocalizedAlert("CHANGE_PASS_FORMAT_FAIL_ALERT_TITLE","CHANGE_PASS_FORMAT_FAIL_ALERT_BODY",["OK_ALERT_BUTTON"],[thisThing.showChangePass], function(){})
              }
            }} appManager={this.props.appManager} text={changePasswordButton} style={[styles.logoutButton, {marginTop:10, marginBottom:10}]} />
        </View>
      </ScrollView>;
    this.props.appActions.setCustomAlertShown(true,customAlert, function(){appActions.requestPop(true);});
  },

  changePassword: function(newPass)
  {
    var thisThing = this;
    var appManager = thisThing.props.appManager;
    var appActions = thisThing.props.appActions;
    var locMan = appManager.getLocalizationManager();
    var changingPassword = appManager.getLocalizationManager().localizedStringForKey("SAVING_HUD");
    thisThing.props.appActions.setSpinnerShown(true, changingPassword)
    NetworkManager.changePassword(this.props.appManager, newPass, function()
    {
      thisThing.props.appActions.setSpinnerShown(false);
      var user = appManager.getCurrentUser(function(currentUser)
      {
        currentUser[ModelConstants.Password] = newPass;
        appManager.setCurrentUser(currentUser, function()
        {
          var changePassSuccessTitle = locMan.localizedStringForKey("CHANGE_PASS_SUCCESS_ALERT_TITLE");
          var changePassSuccessBody = locMan.localizedStringForKey("CHANGE_PASS_SUCCESS_ALERT_BODY");
          var okayButton = locMan.localizedStringForKey("VERSION_OKAY_ALERT_OPTION");

          thisThing.props.appActions.showAlert(changePassSuccessTitle, changePassSuccessBody, [okayButton], [function(){thisThing.props.appActions.hideAlert();appActions.setSpinnerShown(false); appActions.requestPop(true);}], function(){appActions.setSpinnerShown(false); appActions.requestPop(true);})
        });
      })
    }, function(data)
    {
      thisThing.props.appActions.setSpinnerShown(false);
      var title = locMan.localizedStringForKey("CHANGE_PASS_FAIL_ALERT_TITLE");
      var body = locMan.localizedStringForKey("CHANGE_PASS_FAIL_ALERT_BODY");
      var okayButton = locMan.localizedStringForKey("OKAY_ALERT_OPTION");

      thisThing.props.appActions.showAlert(title, body, [okayButton], [function(){thisThing.showChangePass()}], function(){thisThing.props.appActions.hideAlert();appActions.setSpinnerShown(false); appActions.requestPop(true);})
    }, function()
    {
      thisThing.props.appActions.setSpinnerShown(false);
      thisThing.props.appActions.showNetworkErrorAlert(function(){thisThing.showChangePass()}, function(){thisThing.props.appActions.hideAlert();appActions.setSpinnerShown(false); appActions.requestPop(true);});
    },)
  },

  forgotPasswordPressed : function()
  {
    var thisThing = this;
    thisThing._email = ""
    var appManager = thisThing.props.appManager;
    var locManager = thisThing.props.appManager.getLocalizationManager();

    var forgotPasswordFeature = appManager.getFeatureForName("ForgotPassword");
    var forgotPasswordTitle = locManager.localizedStringForKey(forgotPasswordFeature.data.tip);
    var forgotPasswordBody = locManager.localizedStringForKey(forgotPasswordFeature.data.instructions);
    var emailMeButton = locManager.localizedStringForKey("EMAIL_PASSWORD_BUTTON");
    var emailBody = locManager.localizedStringForKey("EMAIL_LABEL");

    var generalColor = 'white';//appManager.getColorForKey("GeneralColor");
    var generalTitleColor = 'black';//appManager.getColorForKey("GeneralTitleColor");
    var bannerColor ='black';// appManager.getColorForKey("FeedCardBannerColor");

    var customAlert =
      <ScrollView bounces={true} style={{margin:0,padding:2,marginLeft:10,marginRight:10}}
        keyboardShouldPersistTaps={true}
        keyboardDismissMode={"interactive"}>
        <View>
          <ReUpText appManager={appManager} isTitle={true} style={{marginTop:10, textAlign:'center'}}>
            {forgotPasswordTitle}
          </ReUpText>
          <ReUpText appManager={appManager} style={{marginTop:10, textAlign:'center'}}>
            {forgotPasswordBody}
          </ReUpText>
          <ReUpField ref={(a)=>{if( typeof a !== 'undefined' && a != null ) a.focus()}} appManager={appManager}
            onChangeText={(newText) => {thisThing._email = newText}}
            placeholder={emailBody}
            secureTextEntry={false}
            autoCapitalize={'none'}
            autoCorrect={false}
            keyboardType={'email-address'}
            tintColor={'black'}
            highlightColor={'black'}
            textInputStyle={{color: generalTitleColor}}/>
          <ReUpButton text={emailMeButton}  onPress={() =>
            {
              var checkingUserLabel = appManager.getLocalizationManager().localizedStringForKey("CHECKING_HUD");
              thisThing.props.appActions.setSpinnerShown(true,checkingUserLabel);
              NetworkManager.forgotPassword(appManager, thisThing._email, function()
              {
                  thisThing.props.appActions.setSpinnerShown(false);
                  var successTitle = locManager.localizedStringForKey("EMAIL_PASS_SUCCESS_ALERT_TITLE");
                  var successBody = locManager.localizedStringForKey("EMAIL_PASS_SUCCESS_ALERT_BODY");
                  var successOkay = locManager.localizedStringForKey("OK_ALERT_BUTTON");

                  thisThing.props.appActions.showAlert(successTitle,successBody,[successOkay],[thisThing.props.appActions.hideAlert], function(){})
              }, function()
              {
                  thisThing.props.appActions.setSpinnerShown(false);
                  var errorTitle = locManager.localizedStringForKey("EMAIL_PASS_FAIL_ALERT_TITLE");
                  var errorBody = locManager.localizedStringForKey("EMAIL_PASS_FAIL_ALERT_BODY");
                  var errorOkay = locManager.localizedStringForKey("OK_ALERT_BUTTON");

                  thisThing.props.appActions.showAlert(errorTitle,errorBody,[errorOkay],[thisThing.forgotPasswordPressed], function(){})
              }, function()
              {
                  thisThing.props.appActions.setSpinnerShown(false);
                  thisThing.props.appActions.showNetworkErrorAlert(thisThing.forgotPasswordPressed, thisThing.forgotPasswordPressed)
              })
            }} appManager={thisThing.props.appManager} style={[styles.logoutButton, {marginTop:10, marginBottom:10}]} />
        </View>
      </ScrollView>;
    this.props.appActions.setCustomAlertShown(true,customAlert);
  },

  registerPressed : function()
  {
    this.props.appActions.requestFeatureName("CreateUser");
  },

  render: function()
  {
    var appManager = this.props.appManager;
    var createUserFeatureData = appManager.getFeatureForName("CreateUser");
    var feedFeatureData = appManager.getFeatureForName("Feed");

    var cardColor = appManager.getColorForKey("FeedCardColor");
    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
    var bannerIconColor = appManager.getColorForKey("FeedCardBannerIconColor");
    var titleColor = appManager.getColorForKey("FeedCardTitleColor");
    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");

    var bgImage = appManager.absoluteResourceForPath(feedFeatureData.data.name + "/" + feedFeatureData.data.bgImage);

    return (
      <View style={styles.container}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
        <Image
          key={appManager.getImageKey("loginbg")}
          style={{position:'absolute', left:0, right:0, bottom:0, top:0}}
          source={{uri: bgImage}}
        />
        <ReUpScrollView responder={this}>
          <FeedCard loginFeatureData={this.props.featureData} createUserFeatureData={createUserFeatureData.data}
            ref={(c) => { this._ref_loginCard = c; }}
            cardType={2}
            iconColor={bannerIconColor}
            bannerColor={bannerColor}
            cardColor={cardColor}
            titleColor={titleColor}
            bodyColor={bodyColor}
            appManager={appManager}
            loginPressed={this.loginPressed}
            registerPressed={this.registerPressed}
            loginFacebookPressed={this.loginFacebookPressed}
            forgotPasswordPressed={this.forgotPasswordPressed}
            />
          <FeedCard createUserFeatureData={createUserFeatureData.data}
            ref={(c) => { this._ref_createCard = c; }}
            cardType={4}
            iconColor={bannerIconColor}
            bannerColor={bannerColor}
            cardColor={cardColor}
            titleColor={titleColor}
            bodyColor={bodyColor}
            appManager={appManager}
            registerPressed={this.registerPressed}
            />
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  image: {
    position: 'absolute',
  },
});

Login.getCards = function(featureData, appActions, data)
{
  var appManager = appActions._appManager;
  var isLoggedIn = appManager.isLoggedIn();

  if( isLoggedIn ) return [];
  else
  {
    var didSelect = function() {appActions.requestFeatureName("Login")};
    var iconName = featureData.data.icon.replace("fa-", "")
    return [{
      didSelect : didSelect,
      title : featureData.data.title,
      body1 : featureData.data.tip,
      icon : iconName,
      cardType : 0,
      sortOrder : 1,
    }];
  }
}

Login.dataDependencies = ["Users"]

module.exports = Login;
